import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const wrapperStyles = ({ theme }) => css`
  display: block;
  padding: 6px;
  color: ${theme.colors.white};
  background: ${theme.colors.p600};

  ${theme.media.kilo} {
    padding: 8px;
  }
`

export const Wrapper = styled('a')(wrapperStyles)
